import { http } from "../../utils/config";

const askQuestionAPI = {
  // Get FAQs with pagination/search
  getAskQuestions: (params = {}) => {
    return http.get("/api/v1/ask-questions", { params });
  },

  // Get FAQ by ID
  getAskQuestionById: (id) => {
    return http.get(`/api/v1/ask-questions/${id}`);
  },

  // Store new FAQ
  storeAskQuestion: (data) => {
    return http.post("/api/v1/ask-questions", data);
  },

  // Update existing FAQ
  updateAskQuestion: (id, data) => {
    return http.put(`/api/v1/ask-questions/${id}`, data);
  },

  // Delete FAQ
  deleteAskQuestion: (id) => {
    return http.delete(`/api/v1/ask-questions/${id}`);
  },

  // Toggle status
  toggleStatusAskQuestion: (id) => {
    return http.patch(`/api/v1/ask-questions/${id}/toggle-status`);
  },

  // Public API for residents
  getPublicAskQuestions: (params = {}) => {
    return http.get("/api/v1/auth/mini-app/ask-questions", { params });
  },
};

// Helper functions for handling API responses
export const askQuestionHelpers = {
  extractAskQuestionData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  extractAskQuestionList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        questions: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  }
};

// Standard error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 400: throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401: throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403: throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404: throw new Error('Không tìm thấy dữ liệu yêu cầu');
          case 422: throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500: throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default: throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        throw new Error('Không thể kết nối đến server');
      } else {
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

export const askQuestionAPIWithErrorHandling = {
  getAskQuestions: withErrorHandling(askQuestionAPI.getAskQuestions),
  getAskQuestionById: withErrorHandling(askQuestionAPI.getAskQuestionById),
  storeAskQuestion: withErrorHandling(askQuestionAPI.storeAskQuestion),
  updateAskQuestion: withErrorHandling(askQuestionAPI.updateAskQuestion),
  deleteAskQuestion: withErrorHandling(askQuestionAPI.deleteAskQuestion),
  toggleStatusAskQuestion: withErrorHandling(askQuestionAPI.toggleStatusAskQuestion),
  getPublicAskQuestions: withErrorHandling(askQuestionAPI.getPublicAskQuestions),
};

export default askQuestionAPI;
